import { MuiTelInput } from "mui-tel-input";

import { styled } from "@mui/material/styles";

const PhoneInput = styled(MuiTelInput)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,

  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    paddingLeft: theme.spacing(0),

    "& .MuiButtonBase-root.MuiIconButton-root": {
      padding: 0,
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    borderRadius: 0,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.secondary.main,
  },

  "& input.MuiInputBase-input": {
    padding: theme.spacing(0, 0, 0.5, 0),
  },

  "& .Mui-error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.primary.main,

    "&.MuiFormHelperText-root": {
      background: "none",
    },
  },

  "& .Mui-error input.MuiInputBase-input::placeholder": {
    color: theme.palette.error.main,
    opacity: 1,
  },

  "& .MuiInputBase-root": {
    ...theme.typography.body1,

    "&:focus": {
      outlineOffset: theme.spacing(0.25),
      outlineWidth: theme.spacing(0.25),
      outlineStyle: "solid",
      borderRadius: 0,
    },

    "&.Mui-error:focus": {
      outlineOffset: theme.spacing(0.25),
      outlineWidth: theme.spacing(0.25),
      outlineStyle: "solid",
      outlineColor: theme.palette.primary.main,
      borderRadius: 0,
    },

    "&.Mui-focused, &:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: 0,
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: theme.palette.secondary.main,
      },
    },

    "&.Mui-error:active, &.Mui-error:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderBottomColor: theme.palette.error.main,
      },
    },

    "&.Mui-error:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderWidth: 2,
      },
    },
  },

  "& .MuiInputBase-multiline": {
    display: "flex",
    flexDirection: "column",

    "& .MuiInputBase-inputMultiline": {
      marginBottom: theme.spacing(1),
    },
  },
}));

export default PhoneInput;
